(() => {
	// Don't run in the admin editor
	if (document.body.classList.contains('block-editor-page')) return;

	const cards = document.querySelectorAll('.block-card-image-link');
	if (!cards.length) return;

	cards.forEach((card) => {
		const anchor = card.querySelector('a');
		if (!anchor) return;

		const href = anchor.getAttribute('href');
		if (!href) return;

		card.style.cursor = 'pointer';
		card.addEventListener('click', (e) => {
			// Don't trigger if clicking the actual link
			if (e.target.closest('a')) return;

			window.location.href = href;
		});
	});
})();
